import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { RADIAL_PROCEDURES } from "../../Data/dataVerificationData";
import "../../Style/components/radial-verification.css";

export default function RadialVerification() {
  const [activeStep, setActiveStep] = useState(0);

  const current = RADIAL_PROCEDURES[activeStep];
  const CurrentIcon = current.icon;

  // 6 radial slices of 60 degrees each
  const total = RADIAL_PROCEDURES.length;
  const radius = 140;
  const innerRadius = 75;

  return (
    <div className="radial-core">
      <div className="radial-core__wheel-wrap">
        <svg viewBox="0 0 320 320" className="radial-core__svg">
          <defs>
            <filter id="glowEffect" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="6" result="blur" />
              <feComposite in="SourceGraphic" in2="blur" operator="over" />
            </filter>
          </defs>

          <g transform="translate(160, 160)">
            {RADIAL_PROCEDURES.map((item, i) => {
              const startAngle = (i * 360) / total - 90;
              const endAngle = ((i + 1) * 360) / total - 90;

              const startRad = (startAngle * Math.PI) / 180;
              const endRad = (endAngle * Math.PI) / 180;

              const x1 = radius * Math.cos(startRad);
              const y1 = radius * Math.sin(startRad);
              const x2 = radius * Math.cos(endRad);
              const y2 = radius * Math.sin(endRad);

              const ix1 = innerRadius * Math.cos(endRad);
              const iy1 = innerRadius * Math.sin(endRad);
              const ix2 = innerRadius * Math.cos(startRad);
              const iy2 = innerRadius * Math.sin(startRad);

              const pathData = `
                M ${x1} ${y1}
                A ${radius} ${radius} 0 0 1 ${x2} ${y2}
                L ${ix1} ${iy1}
                A ${innerRadius} ${innerRadius} 0 0 0 ${ix2} ${iy2}
                Z
              `;

              // Angle for text placement
              const midAngle = ((startAngle + endAngle) / 2 * Math.PI) / 180;
              const tx = (innerRadius + (radius - innerRadius) / 2) * Math.cos(midAngle);
              const ty = (innerRadius + (radius - innerRadius) / 2) * Math.sin(midAngle);

              const isSelected = activeStep === i;

              return (
                <g
                  key={item.id}
                  className={`radial-slice ${isSelected ? "is-selected" : ""}`}
                  onClick={() => setActiveStep(i)}
                >
                  <path
                    d={pathData}
                    fill={item.color}
                    className="radial-slice__path"
                    filter={isSelected ? "url(#glowEffect)" : "none"}
                  />
                  <text
                    x={tx}
                    y={ty + 4}
                    textAnchor="middle"
                    className="radial-slice__text"
                  >
                    {item.step}
                  </text>
                </g>
              );
            })}

            {/* Central Hub Button */}
            <circle cx="0" cy="0" r="62" className="radial-hub__circle" />
            <foreignObject x="-50" y="-50" width="100" height="100">
              <div className="radial-hub__content">
                <CurrentIcon size={22} style={{ color: current.color }} />
                <span>{current.label}</span>
              </div>
            </foreignObject>
          </g>
        </svg>
      </div>

      {/* Synchronized Step Details */}
      <AnimatePresence mode="wait">
        <motion.div
          key={current.id}
          className="radial-core__detail-card"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.25 }}
        >
          <div className="radial-detail__top">
            <span className="radial-badge" style={{ backgroundColor: `${current.color}15`, color: current.color }}>
              Phase {current.step}
            </span>
            <span className="radial-meta">Procedure Node</span>
          </div>
          <h4>{current.title}</h4>
          <p>{current.desc}</p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}